"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GooglePayService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class GooglePayService extends Base_1.BaseService {
    getBaseOptions(data) {
        return this.request({
            url: (0, apiRoutes_1.googlePayStartPaymentUrl)(),
            method: 'post',
            data,
        });
    }
}
exports.GooglePayService = GooglePayService;
//# sourceMappingURL=index.js.map